/* LEVEL COZY personalized hoodie blanket page */
(() => {
  const D = document, H = D.documentElement;
  H.classList.add('lc-js');
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const smooth = () => (reduce() ? 'auto' : 'smooth');
  const rootUrl = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Shipping dates: order today, shipped +2, delivered +7 to +10 calendar days, local time */
  function fmtRange(now, start, end, locale) {
    const day = (n) => new Date(now.getFullYear(), now.getMonth(), now.getDate() + n, 12);
    const a = day(start), b = day(Math.max(start, end));
    const opts = { month: 'short', day: 'numeric' };
    if (b.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
    const f = new Intl.DateTimeFormat(locale, opts);
    let text;
    if (start === end) text = f.format(a);
    else if (f.formatRange) text = f.formatRange(a, b);
    else text = f.format(a) + ' to ' + f.format(b);
    return { a, b, text };
  }
  let shipTimer;
  function updateShipDates() {
    clearTimeout(shipTimer);
    const now = new Date(), loc = H.lang || 'en-US';
    D.querySelectorAll('[data-lc-ship-date]').forEach((el) => {
      const s = Number(el.dataset.start), e = Number(el.dataset.end);
      if (!Number.isFinite(s) || !Number.isFinite(e)) return;
      const r = fmtRange(now, s, e, loc);
      el.textContent = r.text;
      const full = new Intl.DateTimeFormat(loc, { dateStyle: 'long' });
      el.setAttribute('aria-label', s === e ? full.format(r.a) : full.format(r.a) + ' to ' + full.format(r.b));
    });
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    shipTimer = setTimeout(updateShipDates, midnight - now + 200);
  }
  addEventListener('pageshow', updateShipDates);
  D.addEventListener('visibilitychange', () => { if (!D.hidden) updateShipDates(); });

  /* Cart reconciliation: free Player Pack with any blanket, Player 2 code with two or more blankets */
  const Codes = (() => {
    let cfg = null, pending = null;
    async function req(path, body, tries = 2) {
      const r = await fetch(rootUrl() + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
      let d;
      try { d = JSON.parse(await r.text()); } catch (e) {
        if (tries > 1) { await new Promise((z) => setTimeout(z, 500)); return req(path, body, tries - 1); }
        throw Error('Your cart is busy. Please try again in a moment.');
      }
      if (!r.ok || d.status) throw Error(d.description || d.message || 'Your cart could not be updated. Please try again.');
      return d;
    }
    async function reconcile() {
      if (!cfg) return null;
      let cart = await req('cart.js');
      const isMain = (i) => cfg.main.includes(Number(i.variant_id));
      const mainQty = cart.items.filter(isMain).reduce((n, i) => n + i.quantity, 0);
      const gifts = cart.items.filter((i) => Number(i.variant_id) === cfg.gift);
      const wantGift = cfg.gift && mainQty > 0 ? 1 : 0;
      const haveGift = gifts.reduce((n, i) => n + i.quantity, 0);
      const codes = (cart.discount_codes || []).map((d) => d.code);
      const own = [cfg.giftCode, cfg.duoCode].filter(Boolean).map((c) => c.toUpperCase());
      const others = codes.filter((c) => !own.includes(c.toUpperCase()));
      const want = [];
      if (wantGift && cfg.giftCode) want.push(cfg.giftCode);
      if (mainQty >= 2 && cfg.duoCode) want.push(cfg.duoCode);
      const has = (c) => codes.some((x) => x.toUpperCase() === c.toUpperCase());
      const codesOk = want.every(has) && own.filter((c) => !want.map((w) => w.toUpperCase()).includes(c)).every((c) => !has(c));
      const giftFree = gifts.every((i) => i.final_line_price === 0);
      if (haveGift === wantGift && codesOk && (wantGift === 0 || giftFree)) return cart;
      const updates = {};
      if (gifts.length) gifts.forEach((g, k) => { updates[g.key] = k === 0 ? wantGift : 0; });
      else if (wantGift) updates[cfg.gift] = wantGift;
      const drawer = D.querySelector('cart-drawer');
      const sections = (drawer && drawer.getSectionsToRender && drawer.getSectionsToRender().map((x) => x.id)) || [];
      cart = await req('cart/update.js', { updates, discount: [...others, ...want].join(','), sections, sections_url: location.pathname });
      const charged = cart.items.filter((i) => Number(i.variant_id) === cfg.gift && i.final_line_price > 0);
      if (wantGift && charged.length) {
        const rm = {}; charged.forEach((i) => { rm[i.key] = 0; });
        cart = await req('cart/update.js', { updates: rm, sections, sections_url: location.pathname });
        if (drawer && drawer.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
        throw Error('Your blanket is in the cart, but the free Player Pack could not be applied. Please contact us before checkout.');
      }
      if (drawer && drawer.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
      return cart;
    }
    return { set(c) { cfg = c; }, sync() { if (!pending) pending = reconcile().finally(() => { pending = null; }); return pending; } };
  })();
  window.LcCodes = Codes;

  function initReveal() {
    const secs = D.querySelectorAll('.lc-s[data-lc-reveal]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      secs.forEach((s) => io.observe(s));
    } else secs.forEach((s) => s.classList.add('is-in'));
    const catchUp = () => secs.forEach((s) => { if (s.getBoundingClientRect().top < innerHeight) s.classList.add('is-in'); });
    addEventListener('scroll', () => requestAnimationFrame(catchUp), { passive: true });
    catchUp();
  }

  /* Name rules: letters, numbers, spaces and hyphens, 12 characters, the 'S is added for them */
  const cleanName = (v) => {
    let t = (v || '').normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/[’`]/g, "'");
    t = t.replace(/'\s*s\s*$/i, '').replace(/[^A-Za-z0-9 \-]/g, '').replace(/\s{2,}/g, ' ');
    return t.slice(0, 12);
  };

  function init() {
    updateShipDates();
    initReveal();
    const root = D.querySelector('#lcm');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('.lc-proof .ceyla-rproof__text').forEach((p) => p.childNodes.forEach((n) => { if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' '; }));

    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-lc-variants]').textContent); } catch (e) { variants = []; }
    const ds = root.dataset;
    const sizeVal = (k) => (k === 'std' ? ds.sizeStd : ds.sizeKids);
    const findV = (size, bundle) => variants.find((v) => v.size === sizeVal(size) && v.bundle === bundle);
    const duoPct = Number(ds.duoPct || 10) / 100;
    const money = (c) => new Intl.NumberFormat(H.lang || 'en-US', { style: 'currency', currency: ds.currency || 'USD' }).format(c / 100);
    const trimZero = (t) => t.replace(/\.00(?=\D*$)/, '');

    Codes.set({ main: variants.map((v) => v.id), gift: Number(ds.giftVariant) || 0, giftCode: ds.giftCode || '', duoCode: ds.duoCode || '' });

    /* Gallery */
    const g = root.querySelector('[data-lc-gallery]');
    const slides = [...g.querySelectorAll('.lc-slide')];
    const thumbs = [...root.querySelectorAll('.lc-thumb')];
    const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : g.clientWidth) || g.clientWidth;
    const idx = () => Math.max(0, Math.min(slides.length - 1, Math.round(g.scrollLeft / step())));
    const to = (i, instant) => g.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, i)) * step(), behavior: instant ? 'auto' : smooth() });
    root.querySelectorAll('[data-lc-slide]').forEach((b) => b.addEventListener('click', () => to(Number(b.dataset.lcSlide))));
    const nx = root.querySelector('[data-lc-next]'), pv = root.querySelector('[data-lc-prev]');
    if (nx) nx.addEventListener('click', () => to(idx() + 1));
    if (pv) pv.addEventListener('click', () => to(idx() - 1));
    let raf;
    g.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = idx();
        thumbs.forEach((t, j) => { t.classList.toggle('is-on', i === j); t.setAttribute('aria-pressed', String(i === j)); });
        const at = thumbs[i], row = at && at.parentElement;
        if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: at.offsetLeft - row.clientWidth / 2 + at.clientWidth / 2, behavior: smooth() });
        slides.forEach((sl, j) => { const v = sl.querySelector('video'); if (v) { if (j === i) v.play().catch(() => {}); else v.pause(); } });
      });
    }, { passive: true });
    g.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); to(idx() + (e.key === 'ArrowRight' ? 1 : -1)); } });

    /* Players and the Blanket Maker */
    const AV = {"boy":{"cols":3,"tile":512,"names":["base","hair1","hair2","hair3","hair4","hair6","ph1","gl1"],"box":[72,33,439,512]},"girl":{"cols":3,"tile":512,"names":["base","hair1","hair2","hair3","hair4","hair5","hair6","ph1","gl1"],"box":[89,58,421,512]},"man":{"cols":4,"tile":512,"names":["base","tee","hair1","hair2","hair3","hair4","hair5","ph1","ph2","gl1","gl2","bd1","bd2","bd3"],"box":[48,26,467,512]},"woman":{"cols":4,"tile":512,"names":["base","tee","hair1","hair2","hair3","hair4","hair5","hair6","ph1","ph2","gl1","gl2"],"box":[63,34,451,512]}};
    const PAL = {
      skin: [['Fair', [250, 216, 192]], ['Light', [245, 200, 170]], ['Medium', [218, 168, 128]], ['Tan', [186, 132, 92]], ['Brown', [140, 95, 65]], ['Deep', [95, 62, 42]]],
      eyes: [['Blue', [60, 130, 210]], ['Green', [70, 140, 80]], ['Hazel', [150, 110, 50]], ['Brown', [110, 70, 40]], ['Gray', [120, 130, 140]]],
      hair: [['Black', [25, 22, 24]], ['Dark brown', [60, 38, 24]], ['Brown', [110, 70, 40]], ['Blonde', [232, 196, 110]], ['Ginger', [190, 80, 40]], ['Gray', [160, 160, 165]], ['Pink', [240, 110, 180]]],
      top: [['Red', [220, 40, 50]], ['Blue', [40, 120, 230]], ['Green', [40, 170, 80]], ['Purple', [130, 70, 200]], ['Pink', [255, 120, 190]], ['Yellow', [250, 190, 40]], ['Gray', [140, 140, 150]], ['Black', [30, 30, 34]]],
      ctrl: [['Black', [30, 30, 34]], ['White', [240, 240, 245]], ['Blue', [40, 120, 230]], ['Red', [220, 40, 50]], ['Green', [40, 170, 80]], ['Purple', [130, 70, 200]], ['Pink', [255, 120, 190]]],
      phones: [['White', [240, 240, 245]], ['Black', [30, 30, 34]], ['Red', [220, 40, 50]], ['Blue', [40, 120, 230]], ['Pink', [255, 120, 190]], ['Green', [40, 170, 80]]],
      blanket: [['Blue', '#28aaff', 'blue'], ['Red', '#ff3c3c', 'red'], ['Green', '#3cdc5a', 'green'], ['Purple', '#965aff', 'purple']]
    };
    const LAB = (ds.labels || 'Boy|Girl|Man|Woman').split('|');
    const PLAYERS = [['boy', LAB[0]], ['girl', LAB[1]], ['man', LAB[2]], ['woman', LAB[3]]];
    const HAIR = {
      boy: [['hair2', 'Spiky'], ['hair1', 'Textured crop'], ['hair3', 'Curly'], ['hair4', 'Side fringe'], ['hair6', 'Shaggy']],
      girl: [['hair2', 'Ponytail'], ['hair1', 'Long straight'], ['hair3', 'Space buns'], ['hair4', 'Braids'], ['hair5', 'Curly bob'], ['hair6', 'Bob with bangs']],
      man: [['hair2', 'Quiff'], ['hair1', 'Crew cut'], ['hair3', 'Curly'], ['hair4', 'Side part'], ['hair5', 'Man bun'], ['', 'Bald']],
      woman: [['hair2', 'Long waves'], ['hair1', 'Long straight'], ['hair3', 'Sleek bob'], ['hair4', 'Top bun'], ['hair5', 'Ponytail'], ['hair6', 'Big curls']]
    };
    const GLASSES = { kid: [['', 'None'], ['gl1', 'Round']], adult: [['', 'None'], ['gl1', 'Round'], ['gl2', 'Square']] };
    const PHONES = { kid: [['', 'None'], ['ph1', 'Headphones']], adult: [['', 'None'], ['ph1', 'Headphones'], ['ph2', 'Headset with mic']] };
    const BEARD = [['', 'None'], ['bd1', 'Stubble'], ['bd2', 'Short beard'], ['bd3', 'Full beard']];
    const OUTFIT = [['hoodie', 'Hoodie'], ['tee', 'T-shirt']];
    const isKid = (p) => p === 'boy' || p === 'girl';
    const mk = (o) => Object.assign({ player: 'boy', skin: 'Light', eyes: 'Blue', hair: 'hair2', hairColor: 'Brown', beard: '', beardColor: '', outfit: 'hoodie', top: 'Blue', ctrl: 'Black', glasses: '', phones: 'ph1', phonesColor: 'White', blanket: 'blue', name: '', size: 'kids', saved: false }, o);
    const players = { 1: mk({}), 2: mk({ player: 'girl', skin: 'Light', eyes: 'Green', hairColor: 'Ginger', top: 'Purple', ctrl: 'White', phonesColor: 'Pink', blanket: 'red' }) };
    const defaults = { 1: ds.def1 || 'Leo', 2: ds.def2 || 'Mia' };
    const pal = (k, name) => (PAL[k].find((x) => x[0] === name) || PAL[k][0])[1];
    const optLabel = (list, v) => (list.find((x) => x[0] === v) || ['', ''])[1];

    /* Avatar layers: one sheet per player, recolored on the fly by color key */
    const sheets = {};
    const loadSheet = (p) => sheets[p] || (sheets[p] = new Promise((ok, no) => {
      const im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async';
      im.onload = () => ok(im); im.onerror = () => { delete sheets[p]; no(Error('Avatar art could not load. Please check your connection.')); };
      im.src = ds['av' + p[0].toUpperCase() + p.slice(1)];
    }));
    const work = D.createElement('canvas');
    const wctx = work.getContext('2d', { willReadFrequently: true });
    function layersFor(st) {
      const L = [st.outfit === 'tee' && !isKid(st.player) ? 'tee' : 'base'];
      if (st.hair) L.push(st.hair);
      if (st.player === 'man' && st.beard) L.push(st.beard);
      if (st.glasses) L.push(st.glasses);
      if (st.phones) L.push(st.phones);
      return L;
    }
    function recolor(data, st) {
      const C = { 1: pal('hair', st.hairColor), 2: pal('top', st.top), 3: pal('ctrl', st.ctrl), 4: pal('eyes', st.eyes), 5: pal('phones', st.phonesColor), 6: pal('hair', st.beardColor || st.hairColor) };
      const N = {}; Object.keys(C).forEach((k) => { const c = C[k]; N[k] = [c[0] / 255, c[1] / 255, c[2] / 255]; });
      const sk = pal('skin', st.skin), sm = [sk[0] / 255 / 0.96, sk[1] / 255 / 0.78, sk[2] / 255 / 0.66];
      const d = data.data;
      for (let i = 0; i < d.length; i += 4) {
        if (!d[i + 3]) continue;
        const r = d[i] / 255, g = d[i + 1] / 255, b = d[i + 2] / 255;
        const mx = r > g ? (r > b ? r : b) : (g > b ? g : b), mn = r < g ? (r < b ? r : b) : (g < b ? g : b), dl = mx - mn;
        const s = mx > 0 ? dl / mx : 0;
        let h = 0;
        if (dl > 1e-6) { h = mx === r ? (g - b) / dl : mx === g ? 2 + (b - r) / dl : 4 + (r - g) / dl; h = ((h / 6) % 1 + 1) % 1 * 360; }
        const sat = s > 0.38;
        let k = 0;
        if (sat) { if (h >= 280 && h <= 335) k = 1; else if (h >= 85 && h <= 160) k = 2; else if (h >= 205 && h <= 250) k = 3; else if (h >= 170 && h < 205) k = 4; else if (h >= 250 && h < 280) k = 6; }
        if (!k && h >= 45 && h <= 70 && s > 0.5) k = 5;
        if (k) {
          const c = N[k], t = Math.min(mx / 0.92, 1), hl = Math.min(Math.max(1 - s - 0.2, 0), 1) * 0.7;
          d[i] = 255 * Math.min(1, c[0] * t * (1 - hl) + hl * Math.min(c[0] + 0.35, 1));
          d[i + 1] = 255 * Math.min(1, c[1] * t * (1 - hl) + hl * Math.min(c[1] + 0.35, 1));
          d[i + 2] = 255 * Math.min(1, c[2] * t * (1 - hl) + hl * Math.min(c[2] + 0.35, 1));
        } else if ((h < 45 || h > 335) && s > 0.12 && s < 0.75 && mx > 0.25) {
          d[i] = Math.min(255, d[i] * sm[0]); d[i + 1] = Math.min(255, d[i + 1] * sm[1]); d[i + 2] = Math.min(255, d[i + 2] * sm[2]);
        }
      }
      return data;
    }
    /* Draw one player into a work canvas at size px (the full 512 tile, scaled) */
    function compose(im, st, size, L) {
      const A = AV[st.player], T = A.tile;
      work.width = size; work.height = size;
      wctx.clearRect(0, 0, size, size);
      (L || layersFor(st)).forEach((n) => {
        const k = A.names.indexOf(n); if (k < 0) return;
        wctx.drawImage(im, (k % A.cols) * T, Math.floor(k / A.cols) * T, T, T, 0, 0, size, size);
      });
      wctx.putImageData(recolor(wctx.getImageData(0, 0, size, size), st), 0, 0);
      return work;
    }
    /* Place the player on the blanket: centered, feet on the bottom band, same height for every player */
    function place(cv, st, src) {
      const A = AV[st.player], bx = A.box, S = cv.width, f = src.width / A.tile;
      const k = (0.285 * S) / ((bx[3] - bx[1]) * f);
      const c = cv.getContext('2d'); c.clearRect(0, 0, S, S);
      c.drawImage(src, S / 2 - ((bx[0] + bx[2]) / 2) * f * k, 0.813 * S - bx[3] * f * k, src.width * k, src.width * k);
    }
    const bgUrl = (color) => ds['bg' + color[0].toUpperCase() + color.slice(1)];
    function paintPv(pv, st, pn) {
      if (!pv) return;
      pv.dataset.color = st.blanket;
      const bg = pv.querySelector('.lc-pv-bg'), nm = pv.querySelector('[data-lc-pv-name]'), src = bgUrl(st.blanket);
      if (bg && src && bg.dataset.cur !== src) { bg.removeAttribute('srcset'); bg.removeAttribute('sizes'); bg.src = src; bg.dataset.cur = src; }
      const shown = (st.name || defaults[pn] || '').toUpperCase();
      nm.textContent = shown ? shown + "'S" : '';
      nm.style.setProperty('--len', Math.max(4, nm.textContent.length));
      pv.classList.toggle('is-ghost', !st.name);
    }
    async function render(pn) {
      const st = players[pn];
      const targets = [...root.querySelectorAll(`[data-lc-pv="${pn}"]`)];
      if (maker.dlg && maker.pn === pn && maker.dlg.open) targets.push(maker.pv);
      targets.forEach((pv) => paintPv(pv, st, pn));
      let im;
      try { im = await loadSheet(st.player); } catch (e) { if (maker.err) maker.err.textContent = e.message; return; }
      if (players[pn].player !== st.player) return;
      const big = compose(im, st, 512);
      targets.forEach((pv) => { const cv = pv.querySelector('.lc-pv-cv'); if (cv) place(cv, st, big); });
      if (maker.pv && maker.pn === pn) maker.pv.classList.remove('is-loading');
      summary(pn);
    }
    function summary(pn) {
      const st = players[pn];
      const s = root.querySelector(`[data-lc-sum="${pn}"]`), n = root.querySelector(`[data-lc-sum-name="${pn}"]`), b = root.querySelector(`[data-lc-cust-label="${pn}"]`);
      if (!st.saved && !st.name) return;
      const cap = (t) => t.charAt(0).toUpperCase() + t.slice(1);
      if (s) s.textContent = [optLabel(PLAYERS, st.player), st.hair ? cap(st.hairColor.toLowerCase() + ' ' + optLabel(HAIR[st.player], st.hair).toLowerCase()) : 'Bald', st.top + ' ' + (st.outfit === 'tee' && !isKid(st.player) ? 't-shirt' : 'hoodie'), optLabel(PAL.blanket.map((x) => [x[2], x[0]]), st.blanket) + ' blanket'].join('. ') + '.';
      if (n) { n.textContent = st.name ? 'Name: ' + st.name.toUpperCase() + "'S" : 'Name not added yet'; n.classList.toggle('is-set', !!st.name); }
      if (b) b.textContent = 'Edit design';
    }
    const props = (pn) => {
      const st = players[pn], kid = isKid(st.player);
      const p = { Name: st.name.toUpperCase() + "'S", Player: optLabel(PLAYERS, st.player), Blanket: optLabel(PAL.blanket.map((x) => [x[2], x[0]]), st.blanket), 'Skin tone': st.skin, Eyes: st.eyes, Hair: st.hair ? optLabel(HAIR[st.player], st.hair) + ', ' + st.hairColor : 'Bald' };
      if (st.player === 'man') p.Beard = st.beard ? optLabel(BEARD, st.beard) + ', ' + (st.beardColor || st.hairColor) : 'None';
      p.Outfit = st.top + ' ' + (st.outfit === 'tee' && !kid ? 'T-shirt' : 'Hoodie');
      p.Controller = st.ctrl;
      p.Glasses = optLabel(GLASSES[kid ? 'kid' : 'adult'], st.glasses);
      p.Headphones = st.phones ? optLabel(PHONES[kid ? 'kid' : 'adult'], st.phones) + ', ' + st.phonesColor : 'None';
      return p;
    };

    /* The popup */
    const maker = { dlg: D.querySelector('#lcm-maker'), pn: 1 };
    if (maker.dlg) {
      maker.pv = maker.dlg.querySelector('[data-mk-pv]');
      maker.body = maker.dlg.querySelector('[data-mk-body]');
      maker.steps = maker.dlg.querySelector('[data-mk-steps]');
      maker.err = maker.dlg.querySelector('[data-mk-err]');
      maker.ptabs = maker.dlg.querySelector('[data-mk-ptabs]');
    }
    const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const rgb = (c) => `rgb(${c[0]},${c[1]},${c[2]})`;
    function group(key, title, items, cur, kind) {
      return `<div class="lc-mk-grp" data-mk-grp="${key}"><p class="lc-mk-h">${title}<span data-mk-cur="${key}">${esc(cur)}</span></p><div class="lc-mk-opts lc-mk-opts--${kind}" role="radiogroup" aria-label="${esc(title)}">${items}</div></div>`;
    }
    const opt = (key, val, on, inner, label, cls) => `<button type="button" class="lc-mk-o ${cls || ''}" role="radio" aria-checked="${on}" data-k="${key}" data-v="${esc(val)}" aria-label="${esc(label)}">${inner}</button>`;
    function sw(key, list, cur) { return list.map((x) => opt(key, x[0], x[0] === cur, `<i style="background:${Array.isArray(x[1]) ? rgb(x[1]) : x[1]}"></i><small>${esc(x[0])}</small>`, x[0], 'lc-mk-sw')).join(''); }
    function chips(key, list, cur) { return list.map((x) => opt(key, x[0], x[0] === cur, `<span>${esc(x[1])}</span>`, x[1], 'lc-mk-chip')).join(''); }
    function thumbOpts(key, list, cur) { return list.map((x) => opt(key, x[0], x[0] === cur, `<canvas width="120" height="120" data-th="${key}:${esc(x[0])}"></canvas><small>${esc(x[1])}</small>`, x[1], 'lc-mk-th')).join(''); }
    const SECTIONS = [['player', 'Player'], ['face', 'Face'], ['hair', 'Hair'], ['outfit', 'Outfit'], ['gear', 'Gear'], ['blanket', 'Blanket'], ['name', 'Name']];
    function build() {
      const st = players[maker.pn], kid = isKid(st.player), ak = kid ? 'kid' : 'adult';
      const sec = (id, title, html) => `<section class="lc-mk-sec" id="lcm-mk-${id}" data-mk-sec="${id}"><h3>${title}</h3>${html}</section>`;
      let h = '';
      h += sec('player', 'Who is it for?', group('player', 'Player', thumbOpts('player', PLAYERS, st.player), optLabel(PLAYERS, st.player), 'th'));
      h += sec('face', 'Face', group('skin', 'Skin tone', sw('skin', PAL.skin, st.skin), st.skin, 'sw') + group('eyes', 'Eye color', sw('eyes', PAL.eyes, st.eyes), st.eyes, 'sw'));
      let hair = group('hair', 'Hair style', thumbOpts('hair', HAIR[st.player], st.hair), optLabel(HAIR[st.player], st.hair), 'th');
      if (st.hair) hair += group('hairColor', 'Hair color', sw('hairColor', PAL.hair, st.hairColor), st.hairColor, 'sw');
      if (st.player === 'man') {
        hair += group('beard', 'Beard', chips('beard', BEARD, st.beard), optLabel(BEARD, st.beard), 'chip');
        if (st.beard) hair += group('beardColor', 'Beard color', sw('beardColor', PAL.hair, st.beardColor || st.hairColor), st.beardColor || st.hairColor, 'sw');
      }
      h += sec('hair', 'Hair', hair);
      let out = '';
      if (!kid) out += group('outfit', 'Top', chips('outfit', OUTFIT, st.outfit), optLabel(OUTFIT, st.outfit), 'chip');
      out += group('top', kid ? 'Hoodie color' : 'Top color', sw('top', PAL.top, st.top), st.top, 'sw');
      out += group('ctrl', 'Controller color', sw('ctrl', PAL.ctrl, st.ctrl), st.ctrl, 'sw');
      h += sec('outfit', 'Outfit', out);
      let gear = group('glasses', 'Glasses', chips('glasses', GLASSES[ak], st.glasses), optLabel(GLASSES[ak], st.glasses), 'chip');
      gear += group('phones', 'Headphones', chips('phones', PHONES[ak], st.phones), optLabel(PHONES[ak], st.phones), 'chip');
      if (st.phones) gear += group('phonesColor', 'Headphone color', sw('phonesColor', PAL.phones, st.phonesColor), st.phonesColor, 'sw');
      h += sec('gear', 'Gear', gear);
      h += sec('blanket', 'Blanket color', group('blanket', 'Blanket', PAL.blanket.map((x) => opt('blanket', x[2], x[2] === st.blanket, `<i style="background:${x[1]}"></i><small>${x[0]}</small>`, x[0], 'lc-mk-sw lc-mk-sw--big')).join(''), optLabel(PAL.blanket.map((x) => [x[2], x[0]]), st.blanket), 'sw'));
      h += sec('name', 'Their name', `<div class="lc-mk-grp"><label class="lc-mk-h" for="lcm-mk-name">Name on the blanket<span data-mk-count>${st.name.length}/12</span></label><input id="lcm-mk-name" class="lc-name" type="text" maxlength="12" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="${esc(ds.namePh || 'Type their name')}" value="${esc(st.name)}" data-mk-name aria-describedby="lcm-mk-hint"><small id="lcm-mk-hint" class="lc-hint">${esc(ds.nameHint || '')}</small></div>`);
      const top = maker.body.scrollTop;
      maker.body.innerHTML = h;
      maker.body.scrollTop = top;
      maker.steps.innerHTML = SECTIONS.map((x) => `<button type="button" data-mk-go="${x[0]}">${x[1]}</button>`).join('');
      bindName();
      drawThumbs();
      spy();
    }
    async function drawThumbs() {
      const st = players[maker.pn];
      const jobs = [...maker.body.querySelectorAll('canvas[data-th]')];
      for (const cv of jobs) {
        const [key, val] = cv.dataset.th.split(':');
        const t = Object.assign({}, st);
        if (key === 'player') { t.player = val; t.hair = HAIR[val][0][0]; t.beard = ''; t.glasses = ''; t.phones = ''; t.outfit = 'hoodie'; }
        else { t.hair = val; t.phones = ''; t.glasses = ''; }
        let im; try { im = await loadSheet(t.player); } catch (e) { continue; }
        if (!cv.isConnected) return;
        const src = compose(im, t, 240);
        const A = AV[t.player], f = 240 / A.tile, bx = A.box;
        const c = cv.getContext('2d'); c.clearRect(0, 0, 120, 120);
        if (key === 'player') { const w = (bx[2] - bx[0]) * f, hh = (bx[3] - bx[1]) * f, s = 112 / Math.max(w, hh); c.drawImage(src, bx[0] * f, bx[1] * f, w, hh, 60 - w * s / 2, 120 - hh * s, w * s, hh * s); }
        else { const cx = (bx[0] + bx[2]) / 2 * f, side = (bx[2] - bx[0]) * f * 0.92; c.drawImage(src, cx - side / 2, Math.max(0, bx[1] * f - side * 0.12), side, side, 0, 0, 120, 120); }
      }
    }
    function bindName() {
      const nameIn = maker.body.querySelector('[data-mk-name]'), count = maker.body.querySelector('[data-mk-count]');
      if (!nameIn) return;
      nameIn.addEventListener('input', () => {
        const c = cleanName(nameIn.value);
        if (c !== nameIn.value) { const at = nameIn.selectionStart; nameIn.value = c; try { nameIn.setSelectionRange(Math.min(at, c.length), Math.min(at, c.length)); } catch (e) {} }
        players[maker.pn].name = c.trim();
        if (count) count.textContent = c.length + '/12';
        nameIn.classList.remove('is-bad'); maker.err.textContent = '';
        render(maker.pn);
      });
      nameIn.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); save(); } });
    }
    let spyIO;
    function spy() {
      if (spyIO) spyIO.disconnect();
      if (!('IntersectionObserver' in window)) return;
      const btns = [...maker.steps.querySelectorAll('[data-mk-go]')];
      spyIO = new IntersectionObserver((es) => {
        es.forEach((e) => { if (e.isIntersecting) btns.forEach((b) => b.classList.toggle('is-on', b.dataset.mkGo === e.target.dataset.mkSec)); });
      }, { root: maker.body, rootMargin: '0px 0px -70% 0px', threshold: 0 });
      maker.body.querySelectorAll('[data-mk-sec]').forEach((s) => spyIO.observe(s));
    }
    function go(id, focus) {
      const s = maker.body.querySelector(`[data-mk-sec="${id}"]`);
      if (!s) return;
      maker.body.scrollTo({ top: s.offsetTop - maker.body.offsetTop - 4, behavior: smooth() });
      const b = maker.steps.querySelector(`[data-mk-go="${id}"]`);
      if (b) { maker.steps.querySelectorAll('[data-mk-go]').forEach((x) => x.classList.toggle('is-on', x === b)); b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: smooth() }); }
      if (focus) { const i = s.querySelector('input'); if (i) setTimeout(() => i.focus({ preventScroll: true }), 300); }
    }
    function pick(key, val) {
      const st = players[maker.pn];
      let rebuild = false;
      if (key === 'player') {
        if (st.player === val) return;
        const wasKid = isKid(st.player);
        st.player = val; st.hair = HAIR[val][0][0]; st.beard = ''; st.beardColor = ''; st.glasses = ''; st.outfit = 'hoodie';
        if (isKid(val) !== wasKid) st.phones = isKid(val) ? 'ph1' : '';
        if (st.phones && !PHONES[isKid(val) ? 'kid' : 'adult'].some((x) => x[0] === st.phones)) st.phones = 'ph1';
        rebuild = true;
      } else if (key === 'hair') { rebuild = !st.hair !== !val; st.hair = val; }
      else if (key === 'beard') { rebuild = !st.beard !== !val; st.beard = val; }
      else if (key === 'phones') { rebuild = !st.phones !== !val; st.phones = val; }
      else if (key === 'hairColor') { st.hairColor = val; }
      else st[key] = val;
      if (rebuild) build();
      else {
        maker.body.querySelectorAll(`[data-k="${key}"]`).forEach((b) => b.setAttribute('aria-checked', String(b.dataset.v === val)));
        const cur = maker.body.querySelector(`[data-mk-cur="${key}"]`);
        if (cur) { const b = maker.body.querySelector(`[data-k="${key}"][data-v="${CSS.escape(val)}"]`); cur.textContent = b ? b.getAttribute('aria-label') : val; }
        if (key === 'hairColor' || key === 'skin') drawThumbs();
        if (key === 'hairColor' && !st.beardColor) { const bc = maker.body.querySelector('[data-mk-cur="beardColor"]'); if (bc) { bc.textContent = val; maker.body.querySelectorAll('[data-k="beardColor"]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.v === val))); } }
      }
      render(maker.pn);
    }
    function ptabs() {
      if (!maker.ptabs) return;
      maker.ptabs.hidden = tier !== 2;
      maker.ptabs.querySelectorAll('[data-mk-p]').forEach((b) => b.setAttribute('aria-pressed', String(Number(b.dataset.mkP) === maker.pn)));
    }
    function openMaker(pn, step) {
      if (!maker.dlg) return;
      maker.pn = pn; maker.err.textContent = '';
      maker.pv.classList.add('is-loading');
      build(); ptabs();
      if (!maker.dlg.open) { maker.dlg.showModal(); H.classList.add('lc-mk-open'); }
      render(pn);
      requestAnimationFrame(() => { if (step) go(step, step === 'name'); else maker.body.scrollTop = 0; });
      PLAYERS.forEach((p) => loadSheet(p[0]).catch(() => {}));
    }
    function save() {
      const st = players[maker.pn];
      if (!st.name) {
        maker.err.textContent = 'Add their name. It goes on the blanket.';
        go('name', true);
        const i = maker.body.querySelector('[data-mk-name]'); if (i) i.classList.add('is-bad');
        return;
      }
      st.saved = true; summary(maker.pn);
      if (tier === 2 && maker.pn === 1 && !players[2].saved) { openMaker(2); return; }
      maker.dlg.close();
    }
    if (maker.dlg) {
      maker.dlg.addEventListener('click', (e) => {
        const o = e.target.closest('[data-k]'); if (o) { pick(o.dataset.k, o.dataset.v); return; }
        const g2 = e.target.closest('[data-mk-go]'); if (g2) { go(g2.dataset.mkGo); return; }
        const p = e.target.closest('[data-mk-p]'); if (p) { openMaker(Number(p.dataset.mkP)); return; }
        if (e.target.closest('[data-mk-close]')) { maker.dlg.close(); return; }
        if (e.target.closest('[data-mk-done]')) { save(); return; }
        if (e.target === maker.dlg) maker.dlg.close();
      });
      maker.dlg.addEventListener('keydown', (e) => {
        const o = e.target.closest('[role="radio"]');
        if (!o || !['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
        e.preventDefault();
        const all = [...o.parentElement.querySelectorAll('[role="radio"]')], i = all.indexOf(o);
        const n = all[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : all.length - 1)) % all.length];
        n.focus(); pick(n.dataset.k, n.dataset.v);
      });
      maker.dlg.addEventListener('close', () => { H.classList.remove('lc-mk-open'); [1, 2].forEach((pn) => render(pn)); const b = root.querySelector(`.lc-cust[data-lc-open="${maker.pn}"]`); if (b) b.focus({ preventScroll: true }); });
    }
    root.querySelectorAll('[data-lc-open]').forEach((b) => b.addEventListener('click', () => openMaker(Number(b.dataset.lcOpen))));
    [1, 2].forEach((pn) => {
      root.querySelectorAll(`input[name="lc-size-${pn}"]`).forEach((i) => i.addEventListener('change', () => { players[pn].size = i.value; paint(true); }));
    });
    const warm = () => { render(1); if ('requestIdleCallback' in window) requestIdleCallback(() => render(2)); else setTimeout(() => render(2), 600); };
    if ('IntersectionObserver' in window) {
      const card = root.querySelector('[data-lc-player="1"]');
      const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); warm(); } }, { rootMargin: '600px' });
      if (card) io.observe(card); else warm();
    } else warm();

    /* Offer */
    let tier = Number(ds.tier) || 3;
    const tierRadios = [...root.querySelectorAll('[name="lc-tier"]')];
    const addons = [...root.querySelectorAll('[data-lc-addon]')];
    const p2Panel = root.querySelector('[data-lc-player="2"]');
    const addonWrap = root.querySelector('[data-lc-addons]');
    const termsId = root.querySelector('[data-lc-terms-id]');
    const quote = (t) => {
      const s1 = players[1].size, s2 = players[2].size;
      if (t === 3) { const v = findV(s1, ds.bundleKit); return v ? { price: v.price, compare: v.compare, lines: [v], available: v.available, media: v.media } : null; }
      const v1 = findV(s1, ds.bundleSolo);
      if (!v1) return null;
      if (t === 1) return { price: v1.price, compare: v1.compare, lines: [v1], available: v1.available, media: v1.media };
      const v2 = findV(s2, ds.bundleSolo);
      if (!v2) return null;
      const sum = v1.price + v2.price;
      const disc = Math.round(sum * duoPct);
      return { price: sum - disc, compare: (v1.compare || v1.price) + (v2.compare || v2.price), lines: [v1, v2], available: v1.available && v2.available, media: v1.media, unit: Math.round((sum - disc) / 2) };
    };
    const addonTotal = () => (tier === 3 ? 0 : addons.reduce((n, a) => n + (a.checked ? Number(a.dataset.price) : 0), 0));
    const setText = (sel, v) => { const el = root.querySelector(sel); if (el) el.textContent = v; };
    function paint(fromUser) {
      tierRadios.forEach((r) => { r.checked = r.value === String(tier); r.closest('.lc-tier').classList.toggle('is-on', r.checked); });
      [1, 2, 3].forEach((n) => {
        const q = quote(n);
        const pEl = root.querySelector(`[data-lc-tier-price="${n}"]`), cEl = root.querySelector(`[data-lc-tier-compare="${n}"]`);
        if (q && pEl) pEl.textContent = money(q.price);
        if (q && cEl) cEl.textContent = q.compare > q.price ? money(q.compare) : '';
      });
      const q = quote(tier);
      if (!q) return;
      if (p2Panel) { const was = p2Panel.hidden; p2Panel.hidden = tier !== 2; if (was && !p2Panel.hidden) render(2); }
      ptabs();
      if (addonWrap) addonWrap.hidden = tier === 3;
      if (tier === 3) addons.forEach((a) => { a.checked = false; });
      const legend = root.querySelector('[data-lc-size-legend]');
      if (legend) legend.textContent = tier === 2 ? 'Player 1 size' : 'Size';
      const kidsK = findV('kids', tier === 3 ? ds.bundleKit : ds.bundleSolo), stdK = findV('std', tier === 3 ? ds.bundleKit : ds.bundleSolo);
      if (kidsK && stdK) {
        const diff = trimZero('+' + money(stdK.price - kidsK.price));
        root.querySelectorAll('[data-lc-size-diff]').forEach((el) => { el.textContent = diff; });
      }
      setText('[data-lc-price]', money(q.price));
      const c = root.querySelector('[data-lc-compare]'), s = root.querySelector('[data-lc-save]'), u = root.querySelector('[data-lc-unit]');
      if (q.compare > q.price) { c.hidden = false; s.hidden = false; c.textContent = money(q.compare); s.textContent = 'Save ' + trimZero(money(q.compare - q.price)); }
      else { c.hidden = true; s.hidden = true; }
      if (u) { if (q.unit) { u.hidden = false; u.textContent = money(q.unit) + ' per blanket'; } else u.hidden = true; }
      const total = q.price + addonTotal();
      D.querySelectorAll('[data-lc-atc-total]').forEach((el) => { el.textContent = money(total); });
      const sp = D.querySelector('[data-lc-sticky-price]'); if (sp) sp.textContent = money(total);
      if (termsId && termsId.value !== String(q.lines[0].id)) { termsId.value = q.lines[0].id; termsId.dispatchEvent(new Event('change', { bubbles: true })); }
      const main = root.querySelector('.lc-atc[data-lc-add]'); if (main) main.disabled = !q.available;
      D.querySelectorAll('[data-lc-kit-pick]').forEach((b) => { const on = tier === 3; b.setAttribute('aria-pressed', String(on)); const sp2 = b.querySelector('span'); if (sp2) sp2.textContent = on ? sp2.dataset.on : sp2.dataset.off; });
      if (fromUser) {
        const u2 = new URL(location.href); u2.searchParams.set('variant', q.lines[0].id); history.replaceState(history.state, '', u2);
        if (tier === 3 && q.media) {
          const si = slides.findIndex((sl) => sl.dataset.mediaId === String(q.media));
          if (si >= 0 && root.querySelector('.lc-buy').getBoundingClientRect().top < innerHeight) to(si);
        }
        const card = root.querySelector(`[data-tier-card="${tier}"]`);
        if (card && !reduce()) { card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop'); }
      }
    }
    tierRadios.forEach((r) => r.addEventListener('change', () => { tier = Number(r.value); paint(true); }));
    addons.forEach((a) => a.addEventListener('change', () => paint(false)));
    D.querySelectorAll('[data-lc-kit-pick]').forEach((b) => b.addEventListener('click', () => {
      tier = tier === 3 ? 1 : 3; paint(true);
      root.querySelector('.lc-offers').scrollIntoView({ block: 'center', behavior: smooth() });
    }));
    paint(false);
    addEventListener('pageshow', () => paint(false));

    async function drawerReady() {
      await customElements.whenDefined('cart-drawer');
      const d = D.querySelector('cart-drawer');
      if (!d || typeof d.renderContents !== 'function') throw Error('The cart is still loading. Please try again.');
      return d;
    }
    const setCount = (n) => root.querySelectorAll('[data-lc-count]').forEach((e) => { e.textContent = n; });
    const vipFirst = () => {
      const sheet = D.querySelector('.vf-root'), bag = D.querySelector('cart-drawer');
      if (!sheet || !bag || sheet.classList.contains('open')) return;
      const hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
      Object.keys(hide).forEach((p) => bag.style.setProperty(p, hide[p], 'important'));
      let ticks = 0;
      const tm = setInterval(() => { if (sheet.classList.contains('open') || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach((p) => bag.style.removeProperty(p)); } }, 100);
    };
    function check(pn) {
      if (players[pn].name) return true;
      const err = root.querySelector('[data-lc-error]');
      err.textContent = pn === 1 ? 'Add their name in the Blanket Maker first. It goes on the blanket.' : 'Add Player 2’s name in the Blanket Maker too.';
      openMaker(pn, 'name');
      if (maker.err) maker.err.textContent = pn === 1 ? 'Add their name to finish. It goes on the blanket.' : 'Add Player 2’s name to finish.';
      return false;
    }
    let busy = false;
    async function add(e) {
      if (busy) return;
      const btn = e.currentTarget;
      const q = quote(tier);
      if (!q || !q.available) return;
      if (!check(1) || (tier === 2 && !check(2))) return;
      busy = true;
      const buttons = [...D.querySelectorAll('[data-lc-add]')];
      buttons.forEach((b) => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      const err = root.querySelector('[data-lc-error]');
      err.textContent = '';
      try {
        const drawer = await drawerReady();
        if (drawer.setActiveElement) drawer.setActiveElement(btn);
        const sections = drawer.getSectionsToRender().map((s) => s.id);
        const items = q.lines.map((v, k) => ({ id: v.id, quantity: 1, properties: props(k + 1) }));
        if (tier !== 3) addons.forEach((a) => { if (a.checked) items.push({ id: Number(a.dataset.variant), quantity: 1 }); });
        const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections, sections_url: location.pathname }) });
        let data;
        try { data = JSON.parse(await res.text()); } catch (x) { throw Error('Your blanket could not be added. Please try again.'); }
        if (!res.ok || data.status) throw Error(data.description || data.message || 'Your blanket could not be added. Please try again.');
        vipFirst();
        drawer.renderContents(data);
        let cart;
        try { cart = await Codes.sync(); } catch (ge) { err.textContent = ge.message; }
        if (!cart) cart = await fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        setCount(cart.item_count);
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        drawer.open(btn);
      } catch (x) {
        err.textContent = x.message || 'Please check your cart before trying again.';
        err.scrollIntoView({ block: 'center', behavior: smooth() });
      } finally {
        busy = false;
        buttons.forEach((b) => { b.removeAttribute('aria-busy'); b.disabled = false; });
        paint(false);
      }
    }
    D.querySelectorAll('[data-lc-add]').forEach((b) => b.addEventListener('click', add));
    root.querySelectorAll('[data-lc-cart]').forEach((b) => b.addEventListener('click', async () => {
      try {
        const d = await drawerReady();
        await Codes.sync();
        const ids = d.getSectionsToRender().map((s) => s.id);
        const [sections, c] = await Promise.all([fetch(rootUrl() + '?sections=' + ids.join(',')).then((r) => r.json()), fetch(rootUrl() + 'cart.js').then((r) => r.json())]);
        d.renderContents({ id: 0, sections });
        d.classList.toggle('is-empty', c.item_count === 0);
        setCount(c.item_count);
        d.open(b);
      } catch (x) { root.querySelector('[data-lc-error]').textContent = x.message; }
    }));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        clearTimeout(window.__lcSync);
        window.__lcSync = setTimeout(() => Codes.sync().then((c) => c && setCount(c.item_count)).catch((x) => { const el = D.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-lc-error]'); if (el) el.textContent = x.message; }), 150);
      });
    }
    const nd = D.querySelector('cart-drawer');
    if (nd) new MutationObserver(() => {
      const qs = [...nd.querySelectorAll('.cart-drawer-item .quantity__input')];
      if (qs.length) setCount(qs.reduce((n, i) => n + Number(i.value || 0), 0));
      else if (nd.classList.contains('is-empty')) setCount(0);
    }).observe(nd, { subtree: true, childList: true });
    D.addEventListener('click', (e) => {
      const b = e.target.closest('cart-drawer [name="checkout"],cart-drawer a[href$="/checkout"]');
      if (!b || b.dataset.lcReady === '1') return;
      e.preventDefault(); e.stopImmediatePropagation();
      Codes.sync().then(() => {
        const n = D.querySelector('cart-drawer [name="checkout"]') || b;
        n.dataset.lcReady = '1'; n.click(); delete n.dataset.lcReady;
      }).catch((x) => { const el = D.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-lc-error]'); if (el) el.textContent = x.message; });
    }, true);
    Codes.sync().then((c) => c && setCount(c.item_count)).catch(() => {});

    const dlg = D.querySelector('#lcm-policy');
    if (dlg) {
      D.querySelectorAll('[data-lc-policy]').forEach((b) => b.addEventListener('click', () => dlg.showModal()));
      dlg.querySelector('[data-lc-close]').addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    }
    const cBan = D.querySelector('.lc-banner'), cPill = D.querySelector('.lc-concept-pill');
    if (cPill) {
      if (cBan && 'IntersectionObserver' in window) new IntersectionObserver((es) => cPill.classList.toggle('is-on', !es[0].isIntersecting)).observe(cBan);
      else cPill.classList.add('is-on');
    }
    const sticky = D.querySelector('[data-lc-sticky]'), buy = root.querySelector('.lc-buy .lc-atc');
    if (sticky && buy) {
      let sraf;
      const chk = () => {
        cancelAnimationFrame(sraf);
        sraf = requestAnimationFrame(() => {
          const show = buy.getBoundingClientRect().bottom < 0;
          sticky.classList.toggle('is-on', show);
          sticky.setAttribute('aria-hidden', String(!show));
          sticky.querySelector('button').tabIndex = show ? 0 : -1;
        });
      };
      addEventListener('scroll', chk, { passive: true }); addEventListener('resize', chk); chk();
    }
  }

  function widgets() {
    D.querySelectorAll('[data-lc-fit]').forEach((f) => {
      if (f.dataset.ready) return;
      f.dataset.ready = '1';
      const tabs = [...f.querySelectorAll('[data-fx]')], ans = [...f.querySelectorAll('[data-fx-ans]')];
      tabs.forEach((b) => b.addEventListener('click', () => {
        tabs.forEach((x) => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', String(on)); });
        ans.forEach((a) => { a.hidden = a.dataset.fxAns !== b.dataset.fx; });
      }));
    });
  }

  const boot = () => { init(); widgets(); };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  D.addEventListener('shopify:section:load', () => { updateShipDates(); widgets(); D.querySelectorAll('.lc-s[data-lc-reveal]').forEach((s) => s.classList.add('is-in')); });
})();
